/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useLayoutEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppGutter from "../../Common/AppGutter";
import { AppsByCategoryPageEvent, useAppsByCategoryPageDataSelector } from ".";
import { useDispatch } from "react-redux";
import { Waypoint } from "react-waypoint";
import ErrorPage from "../ErrorPage";
import SecondHeader from "../../Common/SecondHeader";
import * as configData from "../../../config.json";
import { LoadingStatus } from "../../../rootReducer/actions";

export default function AppsByCategoryPage() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const pageData = useAppsByCategoryPageDataSelector();
  let parameters: {
    category: string;
  } = useParams();

  useLayoutEffect(() => {
    setCurrentPage(1);
    dispatch({
      type: AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA,
      payload: {
        body: {
          categoryName: parameters.category,
        },
        pageNo: 1,
        pageSize: configData.APPS_PER_PAGE,
      },
    });
    return () => {
      dispatch({
        type: AppsByCategoryPageEvent.RESET,
      });
    };
  }, [parameters.category]);

  const onCallBack = (args: Waypoint.CallbackArgs) => {
    if (currentPage < pageData?.totalPages) {
      dispatch({
        type: AppsByCategoryPageEvent.GET_APPS_BY_CATEGORY_PAGE_DATA,
        payload: {
          body: {
            categoryId: parameters.category,
          },
          pageNo: currentPage + 1,
          pageSize: configData.APPS_PER_PAGE,
        },
      });
      setCurrentPage(currentPage + 1);
    }
    return;
  };

  return (
    <>
      <SecondHeader key="normal" />
      {pageData.loadingStatus === LoadingStatus.LOADING_ERROR ? (
        <ErrorPage />
      ) : (
        <div className="container">
          <AppGutter
            pageData={pageData}
            mainHeading={
              parameters.category.slice(0, 1).toUpperCase() +
              parameters.category.slice(1)
            }
            subHeading={configData.SUB_TITLES.CATEGORY}
            note={configData.INTRO.CATEGORY}
            parameters={parameters}
          />
          {pageData.apps.length !== 0 &&
            pageData.apps.length < pageData.totalElements && (
              <Waypoint onEnter={onCallBack} scrollableAncestor={window} />
            )}
        </div>
      )}
    </>
  );
}
